import FormulaLabel from "../FormulaLabel/FormulaLabel";
import { FormulaSelect } from "../FormulaSelect";
import { useMemo } from "react";
import { filteredObjectByValueTypes } from "../helpers/filteredObjectByValueTypes";

const FunctionRender = ({
  node,
  dropdownData,
  onSelectHandler,
  onDeleteItem,
  onUpdateItem,
  component,
}) => {
  const { argumentsCount, argumentsType } = node;
  const dataForInputs = useMemo(() => {
    return filteredObjectByValueTypes({
      object: dropdownData,
      valueTypes: argumentsType,
    });
  }, [dropdownData, argumentsType]);

  const renderedInputs = argumentsCount.map((currentArgNumber, index) => {
    const isSeparate = index !== argumentsCount.length - 1  && argumentsCount.length > 1;
    
    const isRenderInput = node.children.length < currentArgNumber

    if (isRenderInput) {
      const onSelect = (item) => {
        onSelectHandler(item, {
          currentNodeId: node.id,
          parentId: node.parentId,
          currentChildIndex: currentArgNumber - 1,
        });
      };

      return (
        <>
          <FormulaSelect
            isActive={index === 0}
            key={index}
            onSelectItem={onSelect}
            dropdownData={dataForInputs}
          />
          {isSeparate ? <span>,</span> : null}
        </>
      );
    }

    return null;
  });

  return (
    <>
      <FormulaLabel onDeleteItem={onDeleteItem} key={node.key} onUpdateItem={onUpdateItem} node={node} />

      {component}

      {renderedInputs}

      <span>)</span>
    </>
  );
};

export default FunctionRender;
